import { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { MdHome, MdOutlineVideocam } from 'react-icons/md'
import { useNavigate } from 'react-router-dom'

import { Button, Layout, Text } from '../../components'
import { PATH } from '../../constants'
import { useDeviceIdProvider, useRedialApi } from '../../hooks'

export function FinishFrame() {
  const navigate = useNavigate()
  const { getRoute, deviceId } = useDeviceIdProvider()
  const { data: redialData } = useRedialApi(deviceId)
  const { i18n } = useTranslation()
  const ja = i18n.getFixedT('ja', 'translation', 'frames.finish')
  const en = i18n.getFixedT('en', 'translation', 'frames.finish')

  // useRedialApi returns cached data first time, so we need to check if it has fetched once
  const [redialFetchedOnce, setRedialFetchedOnce] = useState(false)

  useEffect(() => {
    if (redialData) {
      setRedialFetchedOnce(true)
    }
  }, [redialData])

  useEffect(() => {
    if (
      redialData?.call_type === 'redial_from_reception' &&
      redialData.receiver_status === null &&
      redialFetchedOnce
    ) {
      navigate(getRoute(PATH.callback))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [redialData])

  // 10秒後ホームに戻る
  useEffect(() => {
    const redirect = setTimeout(() => {
      window.location.assign(getRoute(PATH.root))
    }, 10000)

    return () => {
      clearTimeout(redirect)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Layout>
      <div className="mb-[20px] wide:mb-[10px]">
        <Text size="lg3" align="center">
          {ja('lead')}
          <br />
          {en('lead')}
        </Text>
      </div>
      <div className="flex w-full flex-col items-center">
        <Text size="heading2" align="center">
          {ja('message')}
          <br />
          {en('message')}
        </Text>
      </div>
      <div className="mt-[60px] flex flex-col items-center gap-y-[30px] wide:mt-[30px]">
        <Button
          className="h-[200px] w-[450px] wide:h-[130px]"
          size="l"
          square
          fill
          onClick={() => {
            navigate(getRoute(PATH.root))
          }}
        >
          <MdHome size={40} />
          <Text size="lg3">
            {ja('home')}
            <br />
            {en('home')}
          </Text>
        </Button>
        <Button
          className="h-[60px] w-[350px]"
          size="l"
          square
          onClick={() => navigate(getRoute(PATH.dial))}
        >
          <MdOutlineVideocam size={35} />
          <Text size="lg1">
            {ja('restart')}
            <br />
            {en('restart')}
          </Text>
        </Button>
      </div>
    </Layout>
  )
}
